import common from "@page/common/js/common";
import MagList from "../components/MagList.vue";

new Vue({
	el: "#mag-list",
	template: `<div><MagList /></div>`,
	components: { MagList },
});
